import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export interface GenerateCampaignPayload {
  restaurantId: string;
  campaign_occasion: string;
  campaign_date: string;
  target_audience: string[];
  campaign_type: string;
  offer_details: string;
  color_theme: string;
  idea_type: string;
  image?: File | null;
}

export interface GenerateCampaignResponse {
  ideaId: number;
  ideaType: string;
  message: string;
}

export interface CampaignGenerationState {
  loading: boolean;
  error: string | null;
  response: GenerateCampaignResponse | null;
}

const initialState: CampaignGenerationState = {
  loading: false,
  error: null,
  response: null,
};

const campaignGenerationSlice = createSlice({
  name: 'campaignGeneration',
  initialState,
  reducers: {
    generateCampaignRequest: (state, action: PayloadAction<GenerateCampaignPayload>) => {
      state.loading = true;
      state.error = null;
      state.response = null;
    },
    generateCampaignSuccess: (state, action: PayloadAction<GenerateCampaignResponse>) => {
      state.loading = false;
      state.response = action.payload;
      state.error = null;
    },
    generateCampaignFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
      state.response = null;
    },
    resetCampaignGeneration: (state) => {
      state.loading = false;
      state.error = null;
      state.response = null;
    },
  },
});

export const {
  generateCampaignRequest,
  generateCampaignSuccess,
  generateCampaignFailure,
  resetCampaignGeneration,
} = campaignGenerationSlice.actions;

export default campaignGenerationSlice.reducer;
